import { createContext, useContext } from "react";

import { ChainCardRef } from "./valueChainState";

// What the cards of the tree view can do to the page, beside what every card
// can (see chainActions). Given through a context, so that a node carries
// only its data.
export interface TreeActions {
  // Opens a subsystem, which closes the one open before; null closes it
  onBranch: (subsystem: string | null) => void;
  // Sets the trail of open kinds; with a card, its parts are read first
  onTrail: (trail: string[], read?: ChainCardRef) => void;
  // Shows a kind in a subsystem: opens the subsystem down to it
  onShow: (card: string, subsystem: string) => void;
}

const noop = () => undefined;

export const TreeActionsContext = createContext<TreeActions>({
  onBranch: noop,
  onTrail: noop,
  onShow: noop,
});

export const useTreeActions = (): TreeActions => useContext(TreeActionsContext);
